function init_we_provide() {
  if ($(window).width() < 1000) return;

  const $leftElement = $('.we-provide-left');
  const $provides = $('.we-provide-right-content').slice(2, 5);

  $leftElement.css({
    position: 'sticky',
    top: '80px',
    alignSelf: 'flex-start'
  });

  $provides.css({
    opacity: 0.1,
    transition: 'opacity 0.1s linear'
  });

  // Throttled scroll handler
  let ticking = false;

  $(window).on('scroll.weProvide', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const viewportCenter = $(window).scrollTop() + $(window).height() / 2;
        $provides.each(function() {
          const $el = $(this);
          const elementCenter = $el.offset().top + $el.height() / 2;
          const distance = Math.abs(elementCenter - viewportCenter);
          const opacity = Math.max(0.1, Math.min(1, 1 - distance / ($(window).height() / 2)));
          $el.css('opacity', opacity);
        });
        ticking = false;
      });
      ticking = true;
    }
  }).trigger('scroll');
  return () => $(window).off('scroll.weProvide');
}

$(window).on('load', () => {
  init_we_provide()
});
